import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { DarkModeContext } from "../context/DarkModeContext";
import useSocket from "../hooks/socket";
const formatCount = (n) => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000)     return `${(n / 1_000).toFixed(1)}K`;
  return n;
};
export default function Header() {
  const { darkMode, toggleDarkMode } = useContext(DarkModeContext);
  const location = useLocation();
  const { connected, socketId, count, log, requestCount } = useSocket();
  return (
    <div>
      <nav
        className={`navbar navbar-expand-md px-3 py-0 ${darkMode ? "navbar-dark bg-dark" : "navbar-light "}`}
      >
        <span className="text-warning m-0 navbar-brand fs-2">ظہور</span>
        <ul className="navbar-nav ms-auto d-flex flex-column flex-md-row gap-3 align-items-start align-items-md-center mt-3 mt-md-0 ">
          <li
            className="nav-item"
            data-toggle="tooltip"
            data-placement="top"
            title={`${count} People currently viewing`}
          >
            {" "}
            <p className="nav-link d-flex align-items-center gap-1 text-warning fw-bold m-0">
              <i className="bi bi-eye"></i>{" "}
              <span className="flip-in">{formatCount(count)}</span>
            </p>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link d-flex align-items-center gap-1 ${location.pathname === "/" ? "text-warning fw-bold" : ""}`}
              to="/"
            >
              <i className="bi bi-house-door"></i>
              Home
            </Link>
          </li>

          <li className="nav-item">
            <Link
              className={`nav-link d-flex align-items-center gap-1 ${location.pathname === "/about" ? "text-warning fw-bold" : ""}`}
              to="/about"
            >
              <i className="bi bi-person"></i>
              About
            </Link>
          </li>

          <li className="nav-item">
            <button
              onClick={toggleDarkMode}
              className="btn btn-warning mt-2 mt-md-0 d-flex align-items-center gap-2"
            >
              <i
                className={`bi ${darkMode ? "bi-moon-fill" : "bi-sun-fill"}`}
              ></i>
              {darkMode ? "Dark" : "Light"}
            </button>
          </li>
        </ul>
      </nav>
      <div class="bg-warning mb-3 w-100" style={{ height: 0.5 }}></div>
    </div>
  );
}
